import * as Types from '../../../../../graphql/src/lib/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type UpdatePasswordMutationVariables = Types.Exact<{
  password: Types.Scalars['String']['input'];
  oldPassword: Types.Scalars['String']['input'];
}>;


export type UpdatePasswordMutation = { __typename?: 'Mutation', updatePassword: boolean };

export const UpdatePasswordDocument = gql`
    mutation UpdatePassword($password: String!, $oldPassword: String!) {
  updatePassword(password: $password, oldPassword: $oldPassword)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePasswordGQL extends Apollo.Mutation<UpdatePasswordMutation, UpdatePasswordMutationVariables> {
    override document = UpdatePasswordDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }